import { useState, useEffect } from 'react'

export function usePersistedState<T>(key: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    const savedValue = localStorage.getItem(key)
    if (savedValue !== null) {
      try {
        return JSON.parse(savedValue)
      } catch {
        return savedValue as T
      }
    }
    return defaultValue
  })

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state))
  }, [key, state])

  return [state, setState]
}
